/* eslint-disable */
/* istanbul ignore file */
//@ts-nocheck
import { config } from "../config";

// ----- generated code from BOLD with some small changes
const bcLoad = () => {
  if (window.bcLoaded) return;
  window.bcLoaded = true;
  const vms = document.createElement("script");
  vms.type = "text/javascript";
  vms.async = true;
  vms.src = `${config.livechatHost}/aid/146590487505554367/bc.vms4/vms.js`;
  const s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(vms, s);
};

export const addNoTranslateClass = (node: HTMLElement | undefined) => {
  if (node) {
    node.setAttribute("class", "notranslate");
  }
};

export const getLiveChat = (
  bccbId: string,
  departmentId: string,
  websiteId: string,
  windowId: string
): void => {
  const div = document.createElement("div");
  div.setAttribute("id", bccbId);
  div.setAttribute("data-id", "bold-chat");
  div.style.visibility = "hidden";
  div.style.height = 0;
  document.body.appendChild(div);
  window._bcvma = window._bcvma || [];
  _bcvma.push(["setAccountID", "146590487505554367"]);
  _bcvma.push(["setParameter", "WebsiteID", websiteId]);
  _bcvma.push(["setParameter", "WindowParameters", "vr=&vi=&ve=&vp=&vn=&lc="]);
  _bcvma.push([
    "addText",
    {
      type: "chat",
      available: "AVAILABLE",
      unavailable: "UNAVAILABLE",
      window: windowId,
      department: departmentId,
      id: bccbId,
    },
  ]);
  if (window.pageViewer && pageViewer.load) pageViewer.load();
  else if (document.readyState == "complete") bcLoad();
  else if (window.addEventListener)
    window.addEventListener("load", bcLoad, false);
  else window.attachEvent("onload", bcLoad);
};
